import type { HumanoidAppearance } from '../GhostRenderer';
import { npc } from './npc';

/** Two captains in the same coastal craft tradition, with separate silhouettes.
 * The ordinary NPC layers own their still poses and idle; ferry authority is elsewhere. */
export const PORT_CAPTAINS: Record<string, HumanoidAppearance> = {
  tidewend_ferrymaster: npc({
    shape: 'classic', color: '#c99972', eyes: 'round', mouth: 'smile',
    humanoid: {
      fit: true,
      hair: { style: 'short', color: '#513e32' },
      headgear: { kind: 'warden_hat', color: '#354e60', accentColor: '#dbbd72' },
      garment: { kind: 'tunic', color: '#477d80', trimColor: '#dfca99', beltColor: '#65503a' },
      props: [{ kind: 'scarf', color: '#d7c99f', stripeColor: '#8c6b44' },
        { kind: 'lantern', glowColor: '#ffd17c' }],
      art: { light: 'lamp', role: 'explorer' },
    },
  }),
  wickhaven_ferrymaster: npc({
    shape: 'wide', color: '#b58e74', eyes: 'round', mouth: 'neutral',
    humanoid: {
      fit: true,
      hair: { style: 'thin', color: '#c6c5b8' },
      beard: { style: 'full', color: '#c6c5b8' },
      cloak: { color: '#3f5149', claspColor: '#cba766' },
      garment: { kind: 'tunic', color: '#455762', trimColor: '#a7b8ab', beltColor: '#66513d' },
      props: [{ kind: 'net', color: '#a59b76' }, { kind: 'lantern', glowColor: '#edc66c' }],
      art: { light: 'lamp', role: 'local' },
    },
  }),
};
